import React from 'react';
import './Changelog.css';
import { updates } from '../updates';

const Changelog: React.FC = () => {
  return (
    <div className="background-gradient">
      <section className="section">
        <div className="container changelog-content">
          <div className="changelog-timeline">
            {updates.map((update) => (
              <div key={update.id} className="changelog-item">
                <div className="changelog-item__date">
                  <span className="changelog-item__emoji">{update.emoji}</span>
                  <span className="changelog-item__date-text">{update.date}</span>
                </div>
                <div className="changelog-item__content card">
                  <h3 className="changelog-item__title">{update.title}</h3>
                  <p className="changelog-item__description">{update.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Changelog;
